import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ComingSoon() {
  const navigate = useNavigate();
  return (
    <div style={{
      minHeight: '100vh',
      background: '#0a0a0a',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: '24px',
      padding: '40px',
    }}>
      <div style={{
        width: '64px',
        height: '64px',
        background: 'rgba(59,130,246,0.1)',
        border: '1px solid rgba(59,130,246,0.2)',
        borderRadius: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2"/>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
      </div>
      <div style={{ textAlign: 'center', maxWidth: '420px' }}>
        <h1 style={{ margin: '0 0 12px', fontSize: '22px', fontWeight: 700, color: '#e5e5e5' }}>
          Module Not Enabled
        </h1>
        <p style={{ margin: 0, fontSize: '14px', color: '#555555', lineHeight: 1.7 }}>
          This module is not enabled for your organisation. Contact your Lemai administrator to request access.
        </p>
      </div>
      <button
        onClick={() => navigate('/dashboard')}
        style={{
          padding: '10px 24px',
          background: 'rgba(59,130,246,0.15)',
          border: '1px solid rgba(59,130,246,0.3)',
          borderRadius: '4px',
          color: '#93c5fd',
          fontSize: '13px',
          fontWeight: 600,
          cursor: 'pointer',
        }}
        onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.background = 'rgba(59,130,246,0.25)'; }}
        onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.background = 'rgba(59,130,246,0.15)'; }}
      >
        Back to Dashboard
      </button>
    </div>
  );
}
